import React, { useContext, useMemo, useState } from 'react';
import { useScreenClass } from 'react-grid-system';
import { ActionMeta } from 'react-select';
import MinimalSelect from './MinimalSelect';
import { UserContext } from '../context/UserContext';
type Props = {
  setSelectedView: (view: 'week' | 'month') => void;
};
const ViewSelect = () => {
  React.useEffect(() => {}, []);
  const screenClass = useScreenClass();
  const userContext = useContext(UserContext);
  const [viewOptions, setViewOptions] = useState<
    Array<{ label: string; value: string }>
  >([
    { label: 'Monthly View', value: 'month' },
    { label: 'Weekly View', value: 'week' },
  ]);
  const [defaultView, setDefaultView] = useState<{
    label: string;
    value: string;
  }>({
    label: 'Monthly View',
    value: 'month',
  });
  const isMobile = useMemo(
    () => ['xs', 'sm'].includes(screenClass),
    [screenClass],
  );
  return (
    <>
      <MinimalSelect
        setClass={isMobile ? 'rs-container' : 'custom-container'}
        placeholder="Select View"
        options={viewOptions}
        defaultValue={userContext.timeView}
        onChange={(newValue: any, actionMeta: ActionMeta<unknown>) => {
          // setSelectedView(newValue.value);
          userContext.setCurrentTimeView(newValue);
        }}
      />
    </>
  );
};

export default ViewSelect;
